import { LoginService } from './login.service';

/** Roles con permiso de persistencia en maestro de empleados (mismo criterio que AuthGuardAdminSupervisor). */
export function esAdminOSupervisor(loginService: LoginService): boolean {
  const rol = loginService.getUserLocalStorage()?.User?.Rol?.toUpperCase() ?? '';
  return rol === 'ADMINISTRADOR' || rol === 'SUPERVISOR';
}
